export default "__VITE_ASSET__c50abbef__"